// extracted by mini-css-extract-plugin
module.exports = {"headerWithFetti":"Common_headerWithFetti__Wlqcm"};